<template>
  <div>

    <div class="history-log-and-memo">

      <div class="history-memo-item"
            v-for="(item, idx) in memoLogs"
            :key="'history-memo'+idx">
        <div style="margin-bottom:2px;">
          <span style="margin-right:8px;">{{ item.created_time }}</span>
          <span>{{ item.author }}</span>
        </div>
        <span style="display:inline-block;white-space:pre-line;">{{ item.content }}</span>
      </div>

    </div>

    <div style="margin-top: 8px">
      <input class="input"
              :placeholder="placeholder"
              style="display: inline-block"
              :value="newMemo"
              @keyup.enter="$emit('onClickHistoryBtn', newMemo)"
              @input="e => newMemo = e.target.value">
      <div class="flex" style="justify-content: flex-end; padding-top: 8px;">
        <button class="button is-primary"
                @click.stop.prevent="$emit('onClickHistoryBtn', newMemo)">입력</button>
      </div>
    </div>

  </div>
</template>

<script>
export default {

  name: 'AdminLogMemo',

  props: {
    memoLogsValue: {
      type: Array,
      required: false,
    },
    newMemoValue: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      memoLogs: [],
      newMemo: ''
    }
  },

  created() {
    this.memoLogs = this.memoLogsValue;
    this.newMemo = this.newMemoValue;
  },

  watch: {
    memoLogsValue(n) {
      this.memoLogs = n;
    },
    newMemoValue(n) {
      this.newMemo = n;
    },
    memoLogs(n) {
      this.$emit('update:memoLogsValue', n);
    },
    newMemo(n) {
      this.$emit('update:newMemoValue', n);
    },
  }

}
</script>

<style lang="stylus" type="stylus" scoped>

  .history-log-and-memo
    width 100%
    height 186px
    font-size .9rem
    display flex
    flex-wrap wrap
    border 1px solid #ddd
    border-radius 3px
    padding 12px
    overflow-y auto

  .history-memo-item
    width 100%
    margin-bottom 12px

</style>
